import type { FormEvent } from 'react';

interface Props {
  code: string;
  newPassword: string;
  loading: boolean;
  onCodeChange: (value: string) => void;
  onNewPasswordChange: (value: string) => void;
  onSubmit: (e: FormEvent) => void;
  onSwitchView: (view: 'login') => void;
}

export default function ResetPasswordForm({
  code,
  newPassword,
  loading,
  onCodeChange,
  onNewPasswordChange,
  onSubmit,
  onSwitchView,
}: Props) {
  return (
    <form onSubmit={onSubmit} className="auth-form">
      <div>
        <h2>New password</h2>
        <p className="auth-subtitle">Enter the code and your new password</p>
      </div>
      <div className="field">
        <label className="field-label" htmlFor="reset-code">
          Reset code
        </label>
        <input
          id="reset-code"
          className="input"
          type="text"
          value={code}
          onChange={(e) => onCodeChange(e.target.value)}
          required
          autoComplete="one-time-code"
          placeholder="123456"
        />
      </div>
      <div className="field">
        <label className="field-label" htmlFor="reset-password">
          New password
        </label>
        <input
          id="reset-password"
          className="input"
          type="password"
          value={newPassword}
          onChange={(e) => onNewPasswordChange(e.target.value)}
          required
          autoComplete="new-password"
          minLength={8}
          placeholder="8+ chars, uppercase, digit"
        />
      </div>
      <button type="submit" className="btn btn-primary" disabled={loading}>
        {loading ? 'Resetting...' : 'Reset Password'}
      </button>
      <div className="auth-links">
        <button type="button" className="link-btn" onClick={() => onSwitchView('login')}>
          Back to sign in
        </button>
      </div>
    </form>
  );
}
